import React from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Label, Button, ErrorText, Stack } from '../components'
import * as t from '../services/translationService'
import { resendVerificationMail, confirmVerifyEmail, updateUser, userInfoError } from '../actions/AuthAction'
import PropTypes from 'prop-types'
import AuthContent from './AuthContent'
import * as networkService from '../services/networkService'
import * as routeService from '../services/routeService'
import styles2 from 'assets/scss/views/Auth2.scss'

const COUNT_LIMIT = 60

class VerifyEmailView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      counter: COUNT_LIMIT,
      showError: false,
      errorMessage: '',
    }
    this.timer = null
  }

  static propTypes = {
    user: PropTypes.any,
    location: PropTypes.any,
    phaseInformationError: PropTypes.any,
    applicationProfileError: PropTypes.any,
    resendVerificationMail: PropTypes.func,
    confirmVerifyEmail: PropTypes.func,
    updateUser: PropTypes.func,
    userInfoError: PropTypes.func,
  }

  componentDidMount() {
    this.startCountdown()
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  startCountdown = () => {
    this.timer = setInterval(() => {
      this.setState(prevState => {
        if (prevState.counter > 0) {
          return { counter: prevState.counter - 1 }
        } else {
          clearInterval(this.timer)
          return null
        }
      })
    }, 1000)
  }

  resetCountdown = () => {
    this.setState({ counter: COUNT_LIMIT }, () => this.startCountdown())
  }

  handleResendEmail = async () => {
    const { user, resendVerificationMail } = this.props
    const { unverifiedEmail } = user

    this.resetCountdown()
    resendVerificationMail(unverifiedEmail)
  }

  handleConfirm = async (userId, token) => {
    const {
      location: { state },
    } = this.props

    const user = await this.props.confirmVerifyEmail(userId, token)
    if (user.email && !user.unverifiedEmail) {
      if (state && state.from) {
        routeService.goToPage(state.from)
      } else {
        routeService.goToRegisterPage({ replace: true })
      }
    } else {
      this.setState({ showError: true, errorMessage: t.verifyEmailNotDone() })
    }
  }

  requestToken = () => {
    const { user, updateUser, userInfoError } = this.props
    const { id: userId, unverifiedEmailRequestToken } = user
    return networkService
      .requestAccessTokenFromEmail(userId, unverifiedEmailRequestToken)
      .then(response => {
        const { accessToken, ...rest } = response.data
        if (accessToken) {
          const information = { token: accessToken, isAuthenticated: true, accessToken, ...rest }
          this.handleConfirm(userId, accessToken)
          updateUser(information)
        } else {
          this.setState({ showError: true, errorMessage: t.verifyEmailNotDone() })
        }
      })
      .catch(err => {
        let jsonData = err.response && err.response.data
        this.setState({ showError: true, errorMessage: jsonData.error.message })
        userInfoError(jsonData)
        return Promise.reject(jsonData)
      })
  }

  handleVerify = async () => {
    this.setState({ showError: false, errorMessage: '' })
    const { user } = this.props
    const {
      id: userId,
      email,
      unverifiedEmail,
      token,
      accessToken,
      unverifiedPhoneIsVerifiable,
      unverifiedEmailRequestToken,
    } = user
    if (token || accessToken) {
      this.handleConfirm(userId, token || accessToken)
      return
    }

    if (!email && unverifiedEmail && !unverifiedPhoneIsVerifiable && unverifiedEmailRequestToken && !token) {
      this.requestToken()
      return
    }

    if (!token && !unverifiedEmailRequestToken) {
      this.setState({ showError: true, errorMessage: t.verifyEmailNotDone() })
    }
  }

  render() {
    const { phaseInformationError, applicationProfileError, user } = this.props

    const showCounter = this.state.counter > 0

    return (
      <React.Fragment>
        <AuthContent title={t.verifyEmailTitle()} hasToken={false}>
          {(phaseInformationError || applicationProfileError) && <ErrorText>{t.generalError()}</ErrorText>}
          <div>
            <Label>{t.verifyEmailMessage(user.unverifiedEmail)}</Label>
            <div className={styles2.Spacer8} />
            <Button onClick={this.handleVerify} fullWidth={true} primary={true}>
              {t.verifyEmailDone()}
            </Button>
          </div>
          {this.state.showError && <ErrorText>{this.state.errorMessage}</ErrorText>}
          <div className={styles2.Spacer8} />
          <Stack spacing="tight">
            <Label>{t.verifyEmailNotRecievedMessage()}</Label>
            <Button plain={true} onClick={this.handleResendEmail} disabled={showCounter}>
              {t.verifyEmailResend()}
              {showCounter && ` (${this.state.counter})`}
            </Button>
          </Stack>
        </AuthContent>
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ AuthReducer, FlowReducer }) => {
  const { user = {}, error } = AuthReducer
  const { phaseInformationError, applicationProfileError } = FlowReducer
  return {
    error,
    user,
    phaseInformationError,
    applicationProfileError,
  }
}

const mapDispatchToProps = dispatch => ({
  resendVerificationMail: email => dispatch(resendVerificationMail(email)),
  confirmVerifyEmail: (userId, token) => dispatch(confirmVerifyEmail(userId, token)),
  updateUser: user => dispatch(updateUser(user)),
  userInfoError: errorData => dispatch(userInfoError(errorData)),
})

export default compose(
  translate('translations'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(VerifyEmailView)



// WEBPACK FOOTER //
// ./src/views/VerifyEmailView.js